import { c as _c } from "react/compiler-runtime";
import { Button, InlineAlert, PageShell } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type ConfirmContinueOnDesktopProps = {
  onConfirmDesktop: () => void;
  onBackToMobile: () => void;
};
const ConfirmContinueOnDesktop = t0 => {
  const $ = _c(29);
  const {
    onConfirmDesktop,
    onBackToMobile
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "transfer.confirmContinueOnDesktop"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <InlineAlert variant="warning">{t4}</InlineAlert>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp4);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onBackToMobile || $[12] !== t6) {
    t7 = <Button fullWidth={true} variant="primary" onClick={onBackToMobile} size="large">{t6}</Button>;
    $[11] = onBackToMobile;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp5);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onConfirmDesktop || $[17] !== t8) {
    t9 = <Button fullWidth={true} variant="secondary" onClick={onConfirmDesktop} size="large">{t8}</Button>;
    $[16] = onConfirmDesktop;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="flex flex-col w-full gap-3">{t7}{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <div className="flex flex-col gap-5">{t5}{t10}</div>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t2 || $[27] !== t3) {
    t12 = <PageShell title={t2} subtitle={t3}>{t11}</PageShell>;
    $[25] = t11;
    $[26] = t2;
    $[27] = t3;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default ConfirmContinueOnDesktop;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.warning;
}
function _temp4($_2) {
  return $_2.cta.mobile;
}
function _temp5($_3) {
  return $_3.cta.desktop;
}